import { useState } from "react";
import { toast } from "sonner";
import { Tag } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { imprimirEtiquetasRecepcion, FORMATOS_RECEPCION } from "@/components/compras/etiquetasRecepcion";

/** Reimpresión de etiquetas de una recepción de compra (confirmada o en borrador). */
export default function ReimprimirEtiquetas({ rec }) {
  const [formato, setFormato] = useState((localStorage.getItem("rc_etiqueta_formato") || "76x51").replace("80x42", "76x51"));
  async function imprimir() {
    try {
      const { data } = await api.get(`/compras/recepciones/${rec.id}/etiquetas`);
      if (!data.etiquetas.length) return toast.error("La recepción no tiene partidas con insumo");
      localStorage.setItem("rc_etiqueta_formato", formato);
      if (!imprimirEtiquetasRecepcion(data, formato)) toast.error("El navegador bloqueó la ventana de impresión"); else toast.success(`${data.etiquetas.length} etiquetas (${formato} mm) enviadas a imprimir`);
    } catch (e) { toast.error(formatApiError(e)); }
  }
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="rc-reimprimir">
      <select data-testid="rc-reimprimir-formato" value={formato} onChange={(e) => setFormato(e.target.value)} className="field h-9 w-32 text-xs">{FORMATOS_RECEPCION.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
      <button type="button" data-testid="rc-reimprimir-btn" onClick={imprimir} className="btn-soft h-9 px-3 text-xs"><Tag className="w-3.5 h-3.5" /> Reimprimir etiquetas</button>
    </div>
  );
}
